import Layout from "@/components/layout";
import Title from "@/components/title";
import { getAllWorkLocation } from "@/fetch/fetchWork";
import { getSetting, updateSetting } from "@/fetch/Pharmagood/fetchSetting";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import Card from "@mui/material/Card";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import React from "react";
import { useNavigate } from "react-router-dom";
const PickupLocationSettingPage = (props) => {
  const { open, setOpen } = props;
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [enableList, setEnableList] = React.useState([]);
  const [disableList, setDisableList] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);

  const navigate = useNavigate();

  const fetch = async () => {
    try {
      const { value } = await getSetting("available-pickup-shop");
      const enableShopId = JSON.parse(value);
      const { data: locations } = await getAllWorkLocation();
      const enabled = _.remove(locations, (location) =>
        enableShopId.includes(location.id),
      );
      if (locations.length > 0) {
        setEnableList(enabled);
        setDisableList(locations);
        setSlideTranOn(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  function not(a, b) {
    return _.filter(a, (v) => v.id !== b.id);
  }

  async function handleOnClickSave() {
    setIsLoading(true);
    try {
      const enableShopId = _.map(enableList, "id");
      await updateSetting("available-pickup-shop", enableShopId);
      setSnackSeverity("success");
      setSnackMessage("更新成功");
    } catch (err) {
      setSnackSeverity("error");
      setSnackMessage(`更新失敗\n${err.message}`);
    } finally {
      setIsLoading(false);
      setSnackOpen(true);
    }
  }
  function moveTo(item, currentPosition) {
    if (currentPosition === "left") {
      setDisableList(_.sortBy(disableList.concat(item), "work_shortcode"));
      setEnableList(_.sortBy(not(enableList, item), "work_shortcode"));
    } else {
      setEnableList(_.sortBy(enableList.concat(item), "work_shortcode"));
      setDisableList(_.sortBy(not(disableList, item), "work_shortcode"));
    }
  }

  React.useEffect(() => {
    fetch();
  }, []);
  const CustomList = (title, items, position = "left") => {
    const [searchText, setSearchText] = React.useState("");
    return (
      <Card>
        <List
          sx={{
            width: 500,
            height: 500,
            bgcolor: "background.paper",
            overflow: "auto",
          }}
          dense
          component="div"
          role="list"
        >
          <ListSubheader>
            <TextField
              placeholder="搜尋店鋪"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon></SearchIcon>
                    </InputAdornment>
                  ),
                  endAdornment:
                    position === "left" ? (
                      <DoneIcon color="success"></DoneIcon>
                    ) : (
                      <ClearIcon color="error"></ClearIcon>
                    ),
                },
              }}
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              fullWidth
            ></TextField>
          </ListSubheader>
          {items
            .filter(
              (i) =>
                i.work_name?.includes(searchText) ||
                i.work_shortcode?.includes(searchText),
            )
            .map((value) => {
              const labelId = `transfer-list-all-item-${value.id}-label`;

              return (
                <ListItemButton
                  key={value.id}
                  role="listitem"
                  onClick={() => {
                    moveTo(value, position);
                    setSearchText("");
                  }}
                >
                  <ListItemText
                    id={labelId}
                    primary={`${value.work_name} (${value.work_shortcode})`}
                  />
                </ListItemButton>
              );
            })}
        </List>
      </Card>
    );
  };
  return (
    <Layout
      header="PickupLocationSettingPage"
      selectedIndex={22}
      open={open}
      setOpen={setOpen}
      snackClose={() => setSnackOpen(false)}
      snackSeverity={snackSeverity}
      snackMessage={snackMessage}
      snackOpen={snackOpen}
    >
      <Title
        history={() => navigate(-1)}
        title="換領地點設定"
        children={
          <div>
            {/* Save Record */}
            <IconButton
              component="label"
              onClick={handleOnClickSave}
              disabled={isLoading}
            >
              <SaveIcon />
            </IconButton>
          </div>
        }
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <Grid
          container
          spacing={2}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <Grid>{CustomList("Choices", enableList, "left")}</Grid>
          <Grid>{CustomList("Chosen", disableList, "right")}</Grid>
        </Grid>
      </Fade>
    </Layout>
  );
};

export default PickupLocationSettingPage;
